import React, { forwardRef, useState } from "react";
import Button from "@mui/material/Button";
import ConfirmDialog from "../../../Common/Dialog/ConfirmDialog";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { Box } from "@mui/material";
import HTMLRenderer from "../../../Common/Html/HTMLRenderer";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="right" ref={ref} {...props} />;
});

export default function ModuleMediaHTMLRender({ media, moduleId, onComplete }) {
    const [open, setOpen] = useState(false);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const title = media.name ? media.name : "Untitled";
    const markdown = media.content ? media.content : "";

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleConfirm = () => {
        onComplete();
        setConfirmDialogOpen(false);
        setOpen(false);
    };

    return (
        <div>
            <Button
                id={`view_mod_${moduleId}`}
                variant="contained"
                onClick={handleClickOpen}
                aria-labelledby={`view_mod_${moduleId} mod_${moduleId}_title`}
                className="btn-medium"
                disableElevation={true}
            >
                View
            </Button>

            <Dialog
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: "fixed" }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography
                            sx={{ ml: 2, flex: 1 }}
                            variant="h6"
                            component="h2"
                        >
                            {title}
                        </Typography>
                        <Button
                            autoFocus
                            variant=""
                            color="primary"
                            onClick={() => setConfirmDialogOpen(true)}
                        >
                            Confirm
                        </Button>
                    </Toolbar>
                </AppBar>

                <Box className="media-placeholder media-placeholder-text">
                    <HTMLRenderer html={markdown} />
                </Box>
            </Dialog>
            <ConfirmDialog
                open={!!confirmDialogOpen}
                title="Confirm"
                content="Please confirm that you have reviewed the associated material"
                confirmButtonLabel="Confirm"
                onConfirm={handleConfirm}
                onCancel={() => setConfirmDialogOpen(false)}
                onClose={() => setConfirmDialogOpen(false)}
            />
        </div>
    );
}
